import { useEffect } from 'react';

function AutoDownloadPDF({ blobData, callback }) {
  useEffect(() => {
    // Only trigger the download if the blobData is available and has a URL
    if (blobData && blobData.url && !blobData.error) {
      // Create a link element
      const link = document.createElement('a');
      link.href = blobData.url;
      link.download = 'activities-licences.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      callback(false)
    }
  }, [blobData]);

  return null;
}

export default AutoDownloadPDF;
